import React from 'react';
import Completed from '../../components/AdminNext/Completed';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';

function action({ store }) {
  if (!store.getState().runtime.isAdminAuthenticated) return { redirect: '/login' };

  return {
    title: 'Completed — Bas Recovery Admin',
    component: (
      <HeadLessLayout>
        <Completed />
      </HeadLessLayout>
    )
  };
}

export default action;
